import React from 'react';
export function ProblemGrid() {
  return <section className="py-20 bg-white" data-id="element-215">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-216">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold text-slate-900 mb-8" data-id="element-217">
          A Hidden Oral Health Problem Most People Never Hear About
        </h2>
        <div className="space-y-5 text-slate-600 text-lg leading-relaxed" data-id="element-218">
          <p data-id="element-219">Most people believe that brushing and flossing are enough.</p>
          <p data-id="element-220">
            But according to emerging research, your mouth contains a delicate
            ecosystem of beneficial and harmful bacteria.
          </p>
          <p data-id="element-221">
            When that balance is disrupted, everyday sugar consumption may
            contribute to an environment that supports plaque buildup, bad
            breath, and declining oral health over time.
          </p>
          <p className="font-semibold text-slate-900" data-id="element-222">The surprising part?</p>
          <p data-id="element-223">
            Many people are unknowingly making the same mistake every single
            day.
          </p>
        </div>
      </div>
    </section>;
}